// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".separator-hor {\n  height: 1px;\n  border: 1px solid #7C878E; }\n", ""]);
// Exports
module.exports = exports;
